export default __webpack_public_path__ + "static/media/pexels-rodnae-productions-7648476.99fcc8f0.jpg";